import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import {
	frmPreguntasOrientacionResultadosAtom,
	puntajeTotalOrientacionResultadosAtom,
} from "../../BandejaEvaluacionStorage";

const usePreguntasOrientacionResultados = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalOrientacionResultadosAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasOrientacionResultadosAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasOrientacionResultados;
